import { FormControl, FormHelperText, Stack } from '@mui/material'
import { formHelperTextClasses } from '@mui/material/FormHelperText'
import { Fragment } from 'react'
import { Controller, UseFormReturn } from 'react-hook-form'
import { ErrorIcon } from '../icons'

interface ButtonFieldErrorProps {
  name: string
  form: UseFormReturn<any, any>
  children: any
  minWidth?: string | number
  marginTop?: string | number
  width?: string | number
}

const ButtonFieldError = ({
  name,
  form,
  children,
  minWidth = '377px',
  marginTop = '8px',
  width,
}: ButtonFieldErrorProps) => {
  const {
    control,
    getValues,
    formState: { errors },
  } = form

  return (
    <Fragment>
      {/* @ts-ignore */}
      <Controller
        render={({ field }) => (
          <FormControl
            variant="standard"
            sx={{
              minWidth: minWidth,
              minHeight: '50px',
              width: width,
              marginTop: marginTop,
              backgroundColor: 'background.overrideDefault',
              borderRadius: '4px',
              [`& .MuiButtonBase-root`]: {
                color:
                  !!errors[name] && !getValues(name) ? '#FF3030' : 'text.main',
                borderBottomLeftRadius: '4px',
                borderBottomRightRadius: '4px',
                backgroundColor:
                  !!errors[name] && !getValues(name)
                    ? 'error.main'
                    : 'background.overrideDefault',
              },
            }}
          >
            {children}
          </FormControl>
        )}
        name={name}
        control={control}
      />
      {!getValues(name) && errors[name]?.message && (
        <Stack direction="row" spacing="5px" mt="3px" color="#FF3030">
          <ErrorIcon />
          <FormHelperText
            id="component-helper-text"
            error
            sx={{
              width: '1',
              fontSize: '12px',
              fontWeight: '400',
              lineHeight: '115%',
              flex: 'none',
              letterSpacing: '0.045em',
              [`&.${formHelperTextClasses.error}`]: {
                color: 'error.main',
                marginLeft: '9px',
                marginTop: '2px',
              },
            }}
          >
            {errors[name]?.message as string}
          </FormHelperText>
        </Stack>
      )}
    </Fragment>
  )
}

export default ButtonFieldError
